import {Component, Input, OnInit} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';

/**
 * This is a helper component that makes it easier to format the side card as the header for the pdf report.
 */
@Component({
    selector: 'app-pdf-reactor-header',
    templateUrl: './pdf-reactor-header.component.html',
    styleUrls: ['./pdf-reactor-header.component.scss'],
    imports: [TranslateModule]
})
export class PdfReactorHeaderComponent implements OnInit {

  @Input() reportType: 'consumer' | 'business' = 'consumer';

  constructor() { }

  ngOnInit(): void {
  }

}
